// Логотип юрлица для КП. Грузим из public/ как base64 (один раз на адрес, потом
// кэш), чтобы вшить и в Excel (ExcelJS.addImage), и в PDF (jsPDF.addImage).
// Без адреса — логотип СпецМашЭлектро, как было до появления бланка МосЭл.

const cache = new Map<string, string | null>()

export async function loadKpLogoBase64(url = '/logo-spm.png'): Promise<string | null> {
  if (cache.has(url)) return cache.get(url) ?? null
  try {
    const res = await fetch(url)
    if (!res.ok) {
      cache.set(url, null)
      return null
    }
    const buf = await res.arrayBuffer()
    const bytes = new Uint8Array(buf)
    let bin = ''
    bytes.forEach((b) => (bin += String.fromCharCode(b)))
    const base64 = btoa(bin)
    cache.set(url, base64)
    return base64
  } catch {
    cache.set(url, null)
    return null
  }
}
